<template>
  <div
    v-if="hasUserInfo"
    class="home-more"
  >
    <span class="more-img"></span>
    <el-dropdown
      trigger="hover"
      class="more-drop"
      :hide-on-click="hideOnClick"
      @visible-change="dropdownChange"
    >
      <div class="el-dropdown-link">
        更多
        <span
          :class="{'arrow-down': !dropVisible, 'arrow-up': dropVisible}"
        ></span>
      </div>
      <el-dropdown-menu
        slot="dropdown"
        ref="dropDown"
        class="home-more-drop"
      >
        <el-dropdown-item
          v-for="item in moreList"
          :key="item.jumpUrl"
          @click.native="handleItem(item)"
        >
          <span v-show="item.jumpUrl">{{ item.name }}</span>
          <el-popover
            v-show="!item.jumpUrl"
            placement="left-end"
            width="200"
            trigger="hover"
            popper-class="popWrapper"
            :offset="50"
          >
            <span slot="reference">{{ item.name }}</span>
            <div class="popContent">
              <img
                src="../../../assets/images/home/ewm.png"
                alt=""
              />
              <p>扫一扫，随时随地查询闲置商标</p>
            </div>
          </el-popover>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import base from '@/utils/js/base';

// 首页更多
export default {
  data() {
    return {
      moreList: [],
      dropVisible: false,
      hideOnClick: false,
    }
  },
  computed: {
    ...mapState('userInfo', {
      hasUserInfo: state => state.hasLoginInfo,
      unreadCount: state => state.unreadCount,
      userInfo: state => state.QDS_LOGIN_INFO_OFFICE,
      partnerType: state => state.partnerType,
      rolePermissionList: state => state.rolePermissionList,
      isClient: state => state.isClient,
    }),
    ...mapState('maintainInfo', {
      maintainStatus: state => state.maintainStatus,
      maintainDate: state => state.maintainDate
    }),
    ...mapState('common', {
      userIdentity: state => state.userIdentity
    }),
  },
  watch: {
    maintainStatus: {
      handler(val) {
        if (val == '0') {
          this.moreList = [];
        }
      },
      immediate: true
    },
    partnerType: {
      handler(val) {
        this.moreList = [];
        if (this.partnerType>=0) {
          console.log(this.isClient);
          if(this.isClient){
            for(let i=0;i<this.rolePermissionList.length;i++){
              if(this.rolePermissionList[i].code=='patent_menu_publish_manage_client'){
                this.moreList.push({
                  name: '发布管理',
                  iconImg: require('@/assets/images/home/icon-fbgl.png'),
                  jumpUrl: '/patentManage'
                })
                continue;
              }
              if(this.rolePermissionList[i].code=='patent_first_page_hhr_home_client'){
                this.moreList.push({
                  name: '我的主页',
                  iconImg: require('@/assets/images/home/icon-fbgl.png'),
                  jumpUrl: '/zlBrokerHome',
                  jumpType: 'target'
                })
                continue;
              }
              if(this.rolePermissionList[i].code=='patent_menu_collect_manage_client'){
                this.moreList.push({
                  name: '我的收藏',
                  iconImg: require('@/assets/images/home/icon-fbgl.png'),
                  jumpUrl: '/patentCollect'
                })
                continue;
              }
              if (this.rolePermissionList[i].code == 'patent_menu_lock_manage') {
                this.moreList.push({
                  name: '锁定管理',
                  iconImg: require('@/assets/images/home/icon-sbgl.png'),
                  jumpUrl: '/lockPatent'
                })
                continue;
              }
              if (this.rolePermissionList[i].code == 'patent_menu_transfer_mark') {
                this.moreList.push({
                  name: '转让标记',
                  iconImg: require('@/assets/images/home/icon-zrbj.png'),
                  jumpUrl: '/transferList'
                })
                continue;
              }
            }
          } else {
            for(let i=0;i<this.rolePermissionList.length;i++){
              if(this.rolePermissionList[i].code=='patent_menu_publish_manage'){
                this.moreList.push({
                  name: '发布管理',
                  iconImg: require('@/assets/images/home/icon-fbgl.png'),
                  jumpUrl: '/patentManage'
                })
                continue;
              }
              if(this.rolePermissionList[i].code=='patent_first_page_hhr_home'){
                this.moreList.push({
                  name: '我的主页',
                  iconImg: require('@/assets/images/home/icon-fbgl.png'),
                  jumpUrl: '/zlBrokerHome',
                  jumpType: 'target'
                })
                continue;
              }
              if(this.rolePermissionList[i].code=='patent_menu_collect_manage'){
                this.moreList.push({
                  name: '我的收藏',
                  iconImg: require('@/assets/images/home/icon-fbgl.png'),
                  jumpUrl: '/patentCollect'
                })
                continue;
              }
              if (this.rolePermissionList[i].code == 'patent_menu_lock_manage') {
                this.moreList.push({
                  name: '锁定管理',
                  iconImg: require('@/assets/images/home/icon-sbgl.png'),
                  jumpUrl: '/lockPatent'
                })
                continue;
              }
              if (this.rolePermissionList[i].code == 'patent_menu_transfer_mark') {
                this.moreList.push({
                  name: '转让标记',
                  iconImg: require('@/assets/images/home/icon-zrbj.png'),
                  jumpUrl: '/transferList'
                })
                continue;
              }
            }
          }

        }
        console.log(this.moreList);
      },
      immediate: true
    },
  },
  mounted(){

  },
  methods: {
    // 更多内容展示
    dropdownChange(visible) {
      this.dropVisible = visible;
    },
    // 点击事件
    handleItem(item){
      if (!this.hasUserInfo) {
        this.$router.push('/login');
        return;
      }
      console.log(item);
      if (!item) return;
      if(item.jumpType=='target'){
        let openPage = null;
        if(location.host=='zl.ipjy365.com'){
          openPage = `https://by.ipjy365.com${item.jumpUrl}?qdsToken=${base.localStorageGet('wxzcTokenValue')}&isClient=${this.isClient?1:0}&fromPath=${this.isClient ? 'qdsClient' : 'PC'}&fromPage=zl`;
        } else {
          openPage = `https://apre-by.ipjy365.com${item.jumpUrl}?qdsToken=${base.localStorageGet('wxzcTokenValue')}&isClient=${this.isClient?1:0}&fromPath=${this.isClient ? 'qdsClient' : 'PC'}&fromPage=zl`;
        }
        window.location.href = openPage;
      } else {
        this.$router.push({path: item.jumpUrl, query :{fromPath: this.isClient==1 ? 'qdsClient' : 'PC'}});
      }
      this.hideOnClick = false
      this.$refs.dropDown.$data.showPopper = true
    }
  }
}
</script>

<style lang="scss" >
  .home-more {
    // width: 100%;
    position: absolute;
    right: 90px;
    top: 14px;
    text-align: right;
    display: inline-block;
    text-align: right;
    .more-img {
      display: inline-block;
      width: 14px;
      height: 14px;
      background: url('../../../assets/images/home/home-more.png') no-repeat center;
      background-size: contain;
    }
    .el-dropdown-link {
      display: inline-block;
      color: $color-text;
      margin: 0px 16px 0 10px;
      .arrow-down {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: url('../../../assets/images/home/arrow-down-gray.png') no-repeat;
        background-size: contain;
      }
      .arrow-up {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: url('../../../assets/images/home/arrow-up-gray.png') no-repeat;
        background-size: contain;
      }
    }
  }
  .popWrapper{
    margin-right: 20px!important;
  }
  .popContent{
    padding: 10px 15px;
    font-size: 12px;
    width: 200px;
    text-align: center;
    img{
      width: 100%;
    }
    p{
      margin-bottom: 6px;
      line-height: 16px;
      margin-top: 10px;
    }
  }
</style>